import React, { FC, memo } from 'react';
import styled from 'styled-components';
import { viewTexts } from '../../../constants/view-texts';
import { MuiInput } from '../../shared/form-element';
import { CreateDialogViewTemplate } from '../create-dialog-template/create-dialog-view-template';

const vt = viewTexts.dialogs.createNewModel;

const InputWrapper = styled.div`
  padding: 5px;
`;

interface Props {
  open: boolean;
  onClose: (reason: 'ok' | 'cancel' | '') => void;
  registererName: string;
  modelName: string | undefined;
  modelNameErrors: string[] | undefined;
  modelNameOnInput: (v: string) => void;
  submitButtonEnabled: boolean;
  nonFieldErrors: string[];
}

export const CreateNewModelViewDialog: FC<Props> = memo(
  ({
    open,
    onClose,
    registererName,
    modelName = '',
    modelNameErrors = [],
    modelNameOnInput,
    submitButtonEnabled,
    nonFieldErrors
  }: Readonly<Props>) => (
    <CreateDialogViewTemplate
      open={open}
      onClose={onClose}
      title={vt.title}
      descriptions={vt.descriptions}
      submitButtonEnabled={submitButtonEnabled}
      nonFieldErrors={nonFieldErrors}
    >
      <InputWrapper>
        <MuiInput
          label={vt.labels.registerer}
          required={true}
          value={registererName}
          disabled={true}
        />
      </InputWrapper>
      <InputWrapper>
        <MuiInput
          label={vt.labels.modelName}
          required={true}
          value={modelName}
          onInput={modelNameOnInput}
          helperText={modelNameErrors.join(' ')}
          error={modelNameErrors.length > 0}
        />
      </InputWrapper>
    </CreateDialogViewTemplate>
  )
);

CreateNewModelViewDialog.displayName = 'CreateNewModelViewDialog';
